import React from 'react';
import { Mic } from 'lucide-react';
import { AnswerMode } from '@/store/interviewStore';
import styles from './AnswerModeToggle.module.scss';

interface AnswerModeToggleProps {
  value: AnswerMode;
  onChange: (mode: AnswerMode) => void;
  disabled?: boolean;
  className?: string;
}

export const AnswerModeToggle: React.FC<AnswerModeToggleProps> = ({
  value,
  onChange,
  disabled,
  className,
}) => {
  const isVoice = value === AnswerMode.Voice;
  return (
    <button
      type="button"
      className={`${styles.modeToggle} ${isVoice ? styles.modeToggleVoice : ''} ${className ?? ''}`}
      onClick={() => onChange(isVoice ? AnswerMode.Text : AnswerMode.Voice)}
      disabled={disabled}
      aria-label="Toggle voice / text mode"
    >
      <span className={`${styles.modeSlot} ${styles.modeSlotAa}`}>Aa</span>
      <span className={`${styles.modeSlot} ${styles.modeSlotMic}`}>
        <Mic style={{ width: '1em', height: '1em' }} />
      </span>
      <span className={styles.modeKnob}>
        {isVoice ? <Mic style={{ width: '1em', height: '1em' }} /> : 'Aa'}
      </span>
    </button>
  );
};
